
export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-[#1A1A2E] to-[#16213E] text-[#F5F1E8] py-12 md:py-16">
      <div className="max-w-[1600px] mx-auto px-6 md:px-8 text-center">
        <h3 className="text-2xl md:text-3xl font-bold mb-4 tracking-wider" style={{ fontFamily: "'Anton', sans-serif" }}>
          송림코리아
        </h3>
        <ul className="space-y-2 text-[#F5F1E8]/80 text-sm md:text-base" style={{ fontFamily: "'Inter', sans-serif" }}>
          <li>대표자: 김덕현</li>
          <li>사업자등록번호: 695-26-01942</li>
          <li>사무실: 경상북도 칠곡군 동명면 금암중앙길 75</li>
          <li>전화번호: 010-9240-3539</li>
        </ul>
      </div>
    </footer>
  );
}
